import React, { useState } from 'react';
import { Handshake, Check, X } from '@phosphor-icons/react';
import { Switch } from '@/components/ui/switch';

export const IntroInbox = ({ intros, onRespond, busy }) => {
  const { incoming = [], connections = [] } = intros || {};
  if (!incoming.length && !connections.length) return null;
  return (
    <div className="home-card" data-testid="intro-inbox">
      {incoming.map((i) => (
        <div key={i.id} className="mb-4" data-testid={`intro-incoming-${i.id}`}>
          <p className="text-xs uppercase tracking-[0.22em] text-bx-volt font-bold inline-flex items-center gap-1.5"><Handshake weight="bold" /> an introduction</p>
          <p className="mt-2 text-white/90">I crossed paths with {i.from_bubble} at {i.place}. Its creator says: “{i.line}”</p>
          {i.why && <p className="mt-1 text-sm text-white/70">{i.why}</p>}
          <p className="mt-1 text-xs text-white/55">Nothing else about you is shared unless you say yes.</p>
          <div className="mt-3 flex gap-2">
            <button disabled={busy} onClick={() => onRespond(i.id, true)} data-testid={`intro-accept-${i.id}`} className="px-4 py-1.5 rounded-full bg-bx-volt text-black text-sm font-bold inline-flex items-center gap-1"><Check weight="bold" /> Yes</button>
            <button disabled={busy} onClick={() => onRespond(i.id, false)} data-testid={`intro-decline-${i.id}`} className="px-4 py-1.5 rounded-full border border-white/25 text-white text-sm inline-flex items-center gap-1"><X weight="bold" /> Not now</button>
          </div>
        </div>
      ))}
      {connections.length > 0 && (
        <div data-testid="intro-connections">
          <p className="text-xs uppercase tracking-[0.22em] text-white/60 font-bold">People you've met</p>
          {connections.map((c) => (
            <p key={c.id} className="mt-2 text-sm text-white/90">@{c.username} <span className="text-white/60">via {c.bubble} — “{c.line}”</span></p>
          ))}
        </div>
      )}
    </div>
  );
};

export const IntroSettings = ({ bubbleName, settings, onSave, busy }) => {
  const [on, setOn] = useState(settings?.allow_intros || false);
  const [line, setLine] = useState(settings?.intro_line || '');
  return (
    <div className="home-card" data-testid="intro-settings">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-white font-bold">Let {bubbleName} meet real people's bubbles</p>
          <p className="text-sm text-white/65">It may suggest introductions. Both of you must say yes, and only the line below is ever shared.</p>
        </div>
        <Switch checked={on} onCheckedChange={setOn} data-testid="intro-allow-switch" />
      </div>
      <input value={line} onChange={(e) => setLine(e.target.value)} maxLength={140} data-testid="intro-line-input"
             placeholder="e.g. I build tiny robots and love late-night jazz"
             className="mt-3 w-full bg-white/5 border border-white/15 rounded-full px-4 py-2 text-sm text-white placeholder:text-white/45 focus:outline-none focus:border-bx-cyan" />
      <button disabled={busy} onClick={() => onSave({ allow_intros: on, intro_line: line })} data-testid="intro-settings-save"
              className="mt-3 px-5 py-2 rounded-full border border-white/25 text-sm font-bold text-white hover:bg-white/10 transition-colors">Save</button>
    </div>
  );
};

export default IntroInbox;
